import { useEffect } from "react";
import isEmpty from "lodash/isEmpty";

import { useActiveProfileQuery } from "graphql/queries/ActiveProfile";
import { apolloClient } from "lib/Apollo";
import { AccountType } from "operations";

export const useInitializePendo = () => {
  const queryResponse = useActiveProfileQuery({
    decodeNodeIds: true,
    client: apolloClient,
  });
  useEffect(() => {
    if (!isEmpty(queryResponse?.data)) {
      const account = queryResponse?.data?.account;
      const user = queryResponse?.data?.user;
      const userEmail = user?.email;
      const emailDomain = userEmail?.split("@").pop();

      (window as any).pendo.initialize({
        visitor: {
          id: user?.id,
          userName: user?.displayName,
          email: userEmail,
          isInternal: emailDomain?.includes("joor"),
          isAdmin: account?.type === AccountType.Admin,
          isProRetailer: user?.assortmentPlanning,
          isLiteRetailer: !user?.assortmentPlanning,
          isProBrand: false,
          isLiteBrand: false,
          // If we want this information, this will require an additional ticket
          // extendedAccountType: null,
        },
        account: {
          id: account?.id,
          name: account?.name,
        },
      });
    }
  }, [queryResponse?.data]);
};
